/* ============================================================
   NORTHSHEEP — is a saved product still there, and still for sale?

   Favourites and recently viewed are stored in the shopper's browser, so they
   keep showing a product long after it sold. Unique hides are unpublished the
   moment they sell out and deleted 60 days later (Shopify Flow), which turns
   every such card into a dead link.

   NsProductStatus.check(handles) → Promise<{ handle: status }>
     'ok'       published and available
     'soldout'  published, nothing left to buy
     'gone'     404 — deleted, archived or taken off the Online Store
     'unknown'  network error, password page, anything else: never acted on

   Each answer comes from templates/product.ns-status.liquid (a few bytes, not
   the full product) and is remembered for 15 minutes in sessionStorage, so a
   shopper moving between pages does not re-ask. At most four requests run at
   once. The same request is never sent twice at the same time.

   Loaded by layout/theme.liquid (with favourites) and by the recently viewed
   section; the guard below makes the second copy a no-op.
   ============================================================ */
(function () {
  'use strict';
  if (window.NsProductStatus) return;

  // v2: the first deploy (16 Sep) cached wrong 'soldout' answers — see ask().
  var KEY = 'northsheep_product_status_v2';
  var TTL = 15 * 60 * 1000;
  var PARALLEL = 4;

  var mem = null;
  function store() {
    if (mem) return mem;
    try { mem = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { mem = {}; }
    return mem;
  }
  function persist() {
    try { sessionStorage.setItem(KEY, JSON.stringify(mem || {})); } catch (e) {}
  }

  // Locale root, not '/': on /de/, /fr/ and /nl/ a bare path answers for the
  // default locale (the same trap ns-favorites.js documents).
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cached(handle) {
    var e = store()[handle];
    return e && Date.now() - e.t < TTL ? e.s : null;
  }

  var inflight = {};
  function ask(handle) {
    if (inflight[handle]) return inflight[handle];
    if (!window.fetch) return Promise.resolve('unknown');
    /* NO `Accept: application/json` header. With it, Shopify ignores
       ?view=ns-status and answers with the product's full JSON representation
       ({"product":{…}}, several KB) — which has no top-level `available`. The
       first version sent that header, read the missing field as "not
       available", and marked in-stock products sold out. */
    inflight[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=ns-status', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (r.status === 404) return 'gone';
        if (!r.ok) return 'unknown';
        return r.text().then(function (t) {
          try {
            var p = JSON.parse(t);
            // Only an explicit true / false counts. Any other shape (a password
            // page, a changed template, the full product JSON) says nothing,
            // so nothing is ever hidden or removed on a guess.
            if (p && p.available === true) return 'ok';
            if (p && p.available === false) return 'soldout';
            return 'unknown';
          } catch (e) {
            return 'unknown';
          }
        });
      })
      .catch(function () { return 'unknown'; })
      .then(function (s) {
        delete inflight[handle];
        if (s !== 'unknown') {
          store()[handle] = { s: s, t: Date.now() };
          persist();
        }
        return s;
      });
    return inflight[handle];
  }

  function check(handles) {
    var out = {};
    var todo = [];
    var seen = {};
    (handles || []).forEach(function (h) {
      if (!h || seen[h]) return;
      seen[h] = true;
      var c = cached(h);
      if (c) out[h] = c;
      else todo.push(h);
    });
    var i = 0;
    function next() {
      if (i >= todo.length) return Promise.resolve();
      var h = todo[i++];
      return ask(h).then(function (s) {
        out[h] = s;
        return next();
      });
    }
    var runners = [];
    for (var k = 0; k < Math.min(PARALLEL, todo.length); k++) runners.push(next());
    return Promise.all(runners).then(function () { return out; });
  }

  window.NsProductStatus = {
    check: check,
    cached: cached,
    // Theme settings → Northsheep sold-out products. Deleted products are
    // always dropped; this switch only decides about sold-out ones.
    hideSoldOut: function () {
      return !!(document.body && document.body.classList.contains('ns-hide-soldout-saved'));
    }
  };
})();
